import React from 'react'
import PropTypes from 'prop-types'

import * as Ant from 'antd'

/** @type {Ant.Switch & React.FC<{ value: boolean }>} */
export const Switch = React.forwardRef(({ value, ...props }, ref) => {
  return (
    <div>
      <Ant.Switch {...props} checked={!!value} ref={ref} />
    </div>
  )
})

Switch.propTypes = {
  ...Ant.Switch.propTypes,
  value: PropTypes.any
}
